module.exports = __webpack_public_path__ + "static/258804c2-9ca6-4856-bad7-67cde4f087b4-b5f2c62758d8206c0efef089529a5f02.woff2";